import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Ourademo.css";
import "./OuraNav.css";
import heroImage from "../assets/images/demo1.png";
import schedulingVideo from "../assets/images/demofeature01.mp4";
import complianceVideo from "../assets/images/docuhubdemo.mp4";
import aaLogo from "../assets/images/AAlogo.png";
import calendarIcon from "../assets/images/calendar.png";
import docHubIcon from "../assets/images/documenthub.png";
import payrollImage from "../assets/images/mobileui.png";

const SECTIONS = [
    {
        id: "hero",
        eyebrow: "Welcome to AAEmployee",
        headline: "The smarter way to manage home health teams.",
        body: "From scheduling to payroll, AAEmployee gives administrators and employees everything they need in one place. See how it works.",
        learnMore: "/admin/login",
        showNext: true,
        media: null,
    },
    {
        id: "scheduling",
        eyebrow: "SCHEDULER",
        headline: "Scheduling that works around your team.",
        body: "Assign shifts, manage clients, and keep your calendar up to date — all from one clean interface built for home health workflows.",
        learnMore: "/scheduler",
        showNext: true,
        media: null,
    },
    {
        id: "payroll",
        eyebrow: "Feature 02",
        headline: "Payroll runs itself when the data is right.",
        body: "Employees can view their schedules and clock in/out all from their phone. Whenever a scheduled employee has completed a shift and clocked out, their information is automatically written to your live payroll spreadsheet.",
        learnMore: "/admin/payroll",
        showNext: true,
        media: null,
    },
    {
        id: "compliance",
        eyebrow: "DOCUMENT ORGANIZER & EDITOR",
        headline: "Every document, exactly where it needs to be.",
        body: "The Document Hub keeps binders, forms, and compliance materials organized by client and section — always accessible, always current.",
        learnMore: "/document-hub",
        showNext: true,
        media: null,
    },
    {
        id: "archive",
        eyebrow: "Explore More",
        headline: "There's more to discover.",
        body: null,
        learnMore: null,
        showNext: false,
        media: null,
    },
];

const CAROUSEL_ITEMS = [
    { label: "Welcome to AAEmployee", section: 0, icon: aaLogo },
    { label: "Scheduling", section: 1, icon: calendarIcon },
    { label: "Payroll Automation", section: 2, icon: null },
    { label: "Document Hub", section: 3, icon: docHubIcon },
    { label: "Explore More", section: 4, icon: null },
];

export default function OuraDemo() {
    const [activeIndex, setActiveIndex] = useState(0);
    const carouselRef = useRef(null);

    const goTo = (index) => {
        if (index >= 0 && index < SECTIONS.length) {
            setActiveIndex(index);
        }
    };

    const scrollCarousel = (dir) => {
        if (carouselRef.current) {
            carouselRef.current.scrollBy({ left: dir * 220, behavior: "smooth" });
        }
    };

    useEffect(() => {
            window.scrollTo(0, 0);
        }, []);

        const active = SECTIONS[activeIndex];



    return (
        <div className="ourademo-root">

            <nav className="apple-global-nav public-nav">
                <div className="left-nav">
                    <a href="#">
                        <Link to="/login">
                            <img src="/images/logoPlaceholder1.png" alt="Logo" className="apple-logo" />
                        </Link>
                    </a>
                </div>
                {/* center nav intentionally removed */}

                <div className="right-nav">
                    <Link
                        to="/admin/register"
                        className="oura-nav-register-btn"
                    >
                        <svg
                            className="oura-nav-register-icon"
                            viewBox="0 0 24 24"
                            aria-hidden="true"
                        >
                            <path d="M4 21h16v-2H4v2zm2-4h3V3H6v14zm5 0h3V7h-3v10zm5 0h3V11h-3v6z" />
                        </svg>

                        <span>Register Organization</span>

                        <svg
                            className="oura-nav-register-arrow"
                            viewBox="0 0 24 24"
                            aria-hidden="true"
                        >
                            <path d="M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6z" />
                        </svg>
                    </Link>
                </div>
            </nav>

            {/* ── MAIN CONTENT ── */}
            <main className="ourademo-main">

                {/* STEPPER */}
                <div className="ourademo-stepper">
                    {SECTIONS.map((section, i) => (
                        <div
                            key={section.id}
                            className={`ourademo-section${i === activeIndex ? " ourademo-section--active" : ""}`}
                        >
                            {section.id !== "archive" && (
                                <div className="ourademo-section-inner">
                                    <p className="ourademo-eyebrow">{section.eyebrow}</p>
                                    <h2 className="ourademo-headline">{section.headline}</h2>
                                    {section.body && <p className="ourademo-body">{section.body}</p>}
                                    <div className="ourademo-actions">
                                        {section.learnMore && (
                                            <Link to={section.learnMore} className="ourademo-cta-btn ourademo-cta-glow">
                                                Learn more
                                            </Link>
                                        )}
                                        {section.showNext && (
                                            <button
                                                className="ourademo-back-btn"
                                                onClick={() => goTo(activeIndex + 1)}
                                            >
                                                Next →
                                            </button>
                                        )}
                                    </div>
                                    <div className="ourademo-dots">
                                        {SECTIONS.map((_, di) => (
                                            <button
                                                key={di}
                                                className={`ourademo-dot${di === activeIndex ? " ourademo-dot--active" : ""}`}
                                                onClick={() => goTo(di)}
                                                aria-label={`Go to section ${di + 1}`}
                                            />
                                        ))}
                                    </div>
                                </div>
                            )}
                            {section.id === "archive" ? (
                                <div className="ourademo-cards">
                                    <div className="ourademo-card">
                                        {/*
                                        <div className="ourademo-card-media" />
                                        */}
                                        <div className="ourademo-card-caption">
                                            <h3 className="ourademo-card-title">Sign in to work across devices</h3>
                                            <p className="ourademo-card-desc">Signing in lets you save and access your schedule, documents, and team data from any device, anywhere.</p>
                                            <Link to="/admin/login" className="ourademo-card-link">Learn more</Link>
                                        </div>
                                    </div>
                                    <div className="ourademo-card">
                                        {/*
                                        <div className="ourademo-card-media" />
                                        */}
                                        <div className="ourademo-card-caption">
                                            <h3 className="ourademo-card-title">Take your team with you</h3>
                                            <p className="ourademo-card-desc">AAEmployee works on any device — desktop, tablet, or phone — so your team stays connected whether they're in the office or in the field.</p>
                                            <Link to="/employee/login" className="ourademo-card-link">Learn more</Link>
                                        </div>
                                    </div>
                                    <div className="ourademo-card">
                                        {/*
                                        <div className="ourademo-card-media" />
                                        */}
                                        <div className="ourademo-card-caption">
                                            <h3 className="ourademo-card-title">Discover every feature</h3>
                                            <p className="ourademo-card-desc">From geofenced clock-ins to applicant tracking and document hubs — explore everything AAEmployee has built for home health teams.</p>
                                            <Link to="/apply" className="ourademo-card-link">Check it out</Link>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="ourademo-section-media">
                                    {section.id === "hero" && (
                                        <img
                                            src={heroImage}
                                            alt="AAEmployee Hero Overview"
                                            className="ourademo-media-image"
                                        />
                                    )}
                                    {section.id === "scheduling" && (
                                        <video
                                            src={schedulingVideo}
                                            autoPlay
                                            loop
                                            muted
                                            playsInline
                                            className="ourademo-media-video"
                                        >
                                            Your browser does not support the video tag.
                                        </video>
                                    )}
                                    {section.id === "payroll" && (
                                        <img
                                            src={payrollImage}
                                            alt="Employee Dashboard UI"
                                            className="ourademo-media-mobileui"
                                        />
                                    )}
                                    {section.id === "compliance" && (
                                        <video
                                            src={complianceVideo}
                                            autoPlay
                                            loop
                                            muted
                                            playsInline
                                            className="ourademo-media-video"
                                        >
                                            Your browser does not support the video tag.
                                        </video>
                                    )}
                                    {section.id !== "hero" && section.id !== "scheduling" && section.id !== "payroll" && section.id !== "compliance" && (
                                        <div className="ourademo-media-placeholder">
                                            <span>{section.eyebrow}</span>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                {/* HORIZONTAL CAROUSEL */}
                <div className="ourademo-carousel-wrap">
                    <button className="ourademo-carousel-arrow ourademo-carousel-arrow--left" onClick={() => scrollCarousel(-1)}>‹</button>
                    <div
                        className="ourademo-carousel"
                        ref={carouselRef}

                    >
                        {CAROUSEL_ITEMS.map((item, i) => (
                            <button
                                key={i}
                                className="ourademo-carousel-item"
                                onClick={() => goTo(item.section)}
                            >
                                <div className="ourademo-carousel-thumb">
                                    {item.icon && (
                                        <img
                                            src={item.icon}
                                            alt=""
                                            className="ourademo-carousel-icon"
                                        />
                                    )}
                                </div>
                                <span className="ourademo-carousel-label">{item.label}</span>
                            </button>
                        ))}
                    </div>
                    <button className="ourademo-carousel-arrow ourademo-carousel-arrow--right" onClick={() => scrollCarousel(1)}>›</button>
                </div>
            </main>

            {/* ── FOOTER ── */}
            <footer className="ourademo-footer">
                <div className="ourademo-footer-social">
                    <span className="ourademo-footer-follow">Follow us</span>
                    <div className="ourademo-footer-icons">
                        <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="ourademo-footer-icon">
                            <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20"><path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 0 0 .5 6.2C0 8.1 0 12 0 12s0 3.9.5 5.8a3 3 0 0 0 2.1 2.1c1.9.6 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 0 0 2.1-2.1C24 15.9 24 12 24 12s0-3.9-.5-5.8zM9.8 15.5V8.5l6.3 3.5-6.3 3.5z"/></svg>
                        </a>
                        <a href="https://x.com" target="_blank" rel="noopener noreferrer" aria-label="X" className="ourademo-footer-icon">
                            <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20"><path d="M18.3 1.6h3.4L14.5 10l8.5 11.4h-7L10.8 14l-6 7.4H1.3l7.7-8.8L1 1.6h7.2l4.6 6.1 5.5-6.1zm-1.2 18.7h1.9L6.8 3.5H4.8L17.1 20.3z"/></svg>
                        </a>
                        <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="ourademo-footer-icon">
                            <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20"><path d="M24 12.1C24 5.4 18.6 0 12 0S0 5.4 0 12.1c0 6 4.4 11 10.1 11.9v-8.4H7.1v-3.5h3V9.4c0-3 1.8-4.6 4.5-4.6 1.3 0 2.7.2 2.7.2v2.9h-1.5c-1.5 0-1.9.9-1.9 1.9v2.2h3.3l-.5 3.5h-2.8V24C19.6 23.1 24 18.1 24 12.1z"/></svg>
                        </a>
                        <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="ourademo-footer-icon">
                            <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20"><path d="M20.4 20.4h-3.6v-5.6c0-1.3 0-3-1.8-3s-2.1 1.4-2.1 2.9v5.7H9.3V9h3.5v1.6h.1c.5-.9 1.6-1.8 3.3-1.8 3.5 0 4.2 2.3 4.2 5.4v6.2zM5.3 7.4a2.1 2.1 0 1 1 0-4.2 2.1 2.1 0 0 1 0 4.2zM3.5 20.4h3.6V9H3.5v11.4zM22.2 0H1.8C.8 0 0 .8 0 1.8v20.4C0 23.2.8 24 1.8 24h20.4c1 0 1.8-.8 1.8-1.8V1.8C24 .8 23.2 0 22.2 0z"/></svg>
                        </a>
                        <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="ourademo-footer-icon">
                            <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20"><path d="M19.6 3.3A4.8 4.8 0 0 1 14.8 0h-3.5v16.4a2.9 2.9 0 0 1-2.9 2.5 2.9 2.9 0 0 1-2.9-2.9 2.9 2.9 0 0 1 2.9-2.9c.3 0 .5 0 .8.1V9.6a6.4 6.4 0 0 0-.8-.1 6.4 6.4 0 0 0-6.4 6.4 6.4 6.4 0 0 0 6.4 6.4 6.4 6.4 0 0 0 6.4-6.4V8.2a8.2 8.2 0 0 0 4.8 1.5V6.3a4.8 4.8 0 0 1-3-3z"/></svg>
                        </a>
                    </div>
                </div>
                <div className="ourademo-footer-bottom">
                    <div className="ourademo-footer-inner">
                        <span className="ourademo-footer-brand">© 2026 Oura Business Solutions</span>
                        <nav className="ourademo-footer-links">
                            <Link to="/">Home</Link>
                            <Link to="/apply">Apply</Link>
                            <Link to="/admin/login">Admin Login</Link>
                            <a href="mailto:info@ouralife.net">Support</a>
                        </nav>
                        <p className="ourademo-footer-legal">
                            AAEmployee is a workforce management platform built for home health agencies.
                            All rights reserved.
                        </p>
                    </div>
                </div>
            </footer>

        </div>
    );
}